import Answer from './Answer.class'
import axios from 'axios'
import { get } from 'lodash'
import Subquestion from './Subquestion.class'
const baseURL = '/api/test/'

export default class Question {
	constructor (init = {}, forTour = false) {
		this.id = get(init, 'id') ? init.id : null
		this.test_id = get(init, 'test_id') ? init.test_id : null
		this.question = get(init, 'question') ? init.question : ''
		this.question_number = get(init, 'question_number') ? init.question_number : null
		this.question_type = get(init, 'question_type') ? init.question_type : 'choice'
		this.answers = get(init, 'answers') ? this.createAnswers(init.answers, forTour) : []
		this.subquestions = get(init, 'subquestions') ? this.createSubquestions(init.subquestions) : []
		this.isOpenTab = true
		this.errors = {}
		this.forTour = !!forTour
	}

	static url = baseURL

	get hasAnswers () {
		if (this.question_type === 'personal') {
			return true
		} else if (this.question_type === 'conformity') {
			return this.subquestions.length
		} else {
			return this.answers.length
		}
	}

	get findEmptyAnswer () {
		if (this.question_type === 'conformity') {
			return this.subquestions.findIndex(item => !item.subquestion)
		} else {
			return this.answers.findIndex(item => !item.answer)
		}
	}

	deleteEmptyAnswer () {
		while (this.findEmptyAnswer >= 0) {
			this.answers.splice(this.findEmptyAnswer, 1)
		}
	}

	get formDataDelete () {
		const formData = new URLSearchParams()
		formData.append(`question[0][id]`, this.id)
		formData.append(`question[0][delete]`, 1)
		return formData
	}

	delete () {
		return axios.put(`${baseURL}${this.test_id}/question`, this.formDataDelete)
	}

	formData (formData, index) {
		if (this.id) {
			formData.append(`question[${index}][id]`, this.id)
		} else {
			formData.append(`question[${index}][type]`, this.question_type)
		}
		formData.append(`question[${index}][question_number]`, this.question_number)
		formData.append(`question[${index}][question]`, this.question)

		if (this.question_type === 'conformity') {
			this.subquestions.forEach((subquestionItem, subquestionIndex) => {
				subquestionItem.formData(formData, subquestionIndex, index, this.question_type)
			})
		} else {
			this.answers.forEach((answerItem, answerIndex) => {
				answerItem.formData(formData, answerIndex, index, this.question_type)
			})
		}
	}

	/**
	 * @param {Array<Object>} arr
	 * @param {boolean} forTour
	 * @returns {Answer[]}
	 */
	createAnswers (arr, forTour = false) {
		if (Array.isArray(arr) && arr.length) {
			const arrObjects = arr.map(item => new Answer({...item, test_id: this.test_id}, forTour))
			return arrObjects.sort(function (a, b) {
				if (a.answer_number > b.answer_number) return 1
				if (a.answer_number <= b.answer_number) return -1
			})
		} else {
			return []
		}
	}
	createSubquestions (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new Subquestion({...item, test_id: this.test_id}))
		} else {
			return []
		}
	}

	static questionTypeList = [
		{
			code: 'choice',
			name: 'Тест'
		},
		{
			code: 'textual',
			name: 'Текстовый вопрос'
		},
		{
			code: 'personal',
			name: 'Развёрнутый вопрос для самопроверки'
		},
		{
			code: 'order',
			name: 'Правильный порядок'
		},
		{
			code: 'conformity',
			name: 'Соответствие'
		}
	]

	static questionTypeListForTour = [
		{
			code: 'choice',
			name: 'Тест'
		},
		{
			code: 'personal',
			name: 'Текстовый вопрос'
		}
	]
}



// WEBPACK FOOTER //
// ./src/assets/js/Test/Question.class.js